import { render, staticRenderFns } from "./PhoneData.vue?vue&type=template&id=bc5dd35c&scoped=true"
import script from "./PhoneData.vue?vue&type=script&lang=js"
export * from "./PhoneData.vue?vue&type=script&lang=js"
import style0 from "./PhoneData.vue?vue&type=style&index=0&id=bc5dd35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5dd35c",
  null
  
)

export default component.exports